export default __webpack_public_path__ + "static/media/md-arrow-dropdown.9b14ce39.svg";